/*
  NOTE:
  Stable Gennie Pickup helper.
  - Adds a custom pickup method class for styling.
  - Adds a "Use my location" button beside the postcode/search field.
  - Sorts pickup locations only when customer enters a postcode or clicks the location button.
  - Shows only the first 6 pickup stores, then a Show all / Show fewer button.
  - Does not re-sort on every app DOM mutation, which prevents mobile scroll flicker.
*/

(function() {
  var ROOT_SELECTOR = '#genie-store-pickup-front-holder, #genie-store-pickup-front-holder-drawer';
  var METHOD_SELECTOR = '.checkoutMethod';
  var LIMIT = 3;
  var SUBURB_DISTANCE_LIMIT_KM = 15;
  var SORT_DEBOUNCE_MS = 250;
  var SYNC_DEBOUNCE_MS = 120;
  var pageWatcherStarted = false;

  var STORE_COORDS_BY_NAME = {
    'sg bakery coolum beach': { lat: -26.5266291, lng: 153.0888414 },
    'sg bakery gympie': { lat: -26.1882125, lng: 152.6616719 },
    'sg bakery noosa civic': { lat: -26.414029, lng: 153.048493 },
    'sg bakery nambour': { lat: -26.6260284, lng: 152.9614839 },
    'sg bakery buderim': { lat: -26.6863972, lng: 153.049552 },
    'sg bakery bellmere': { lat: -27.0917742575871, lng: 152.890514181477 },
    'sg bakery caboolture': { lat: -27.0594243, lng: 152.9596002 },
    'sg bakery north lakes': { lat: -27.2423158, lng: 153.0166917 },
    'big bun bakery': { lat: -27.065631, lng: 153.1507131 },
    'sg bakery burpengary': { lat: -27.1388919, lng: 152.983107 },
    'sg bakery helensvale': { lat: -27.9285799, lng: 153.3364558 },
    'sg bakery ormeau': { lat: -27.7858264, lng: 153.2509643 },
    'sg bakery carseldine': { lat: -27.3488722, lng: 153.0263171 },
    'tiffany\'s cakes & pastries': { lat: -27.38854, lng: 152.97821 }
  };

  var STORE_LOCATION_DATA_BY_NAME = {
    'sg bakery coolum beach': { postcode: 4573, tokens: ['coolum beach', 'coolum village', '4573'] },
    'sg bakery gympie': { postcode: 4570, tokens: ['gympie', 'monkland', '4570'] },
    'sg bakery noosa civic': { postcode: 4566, tokens: ['noosa civic', 'noosaville', '4566'] },
    'sg bakery nambour': { postcode: 4560, tokens: ['nambour', 'nambour plaza', '4560'] },
    'sg bakery buderim': { postcode: 4556, tokens: ['buderim', 'burnett', '4556'] },
    'sg bakery bellmere': { postcode: 4510, tokens: ['bellmere', '96 bellmere', '4510'] },
    'sg bakery caboolture': { postcode: 4510, tokens: ['caboolture', 'pumicestone', 'ardrossan', '4510'] },
    'sg bakery north lakes': { postcode: 4509, tokens: ['north lakes', 'westfield north lakes', '4509'] },
    'big bun bakery': { postcode: 4507, tokens: ['big bun', 'bellara', 'benabrow', '4507'] },
    'sg bakery burpengary': { postcode: 4505, tokens: ['burpengary', 'uhlmann', '4505'] },
    'sg bakery helensvale': { postcode: 4212, tokens: ['helensvale', 'westfield helensvale', '4212'] },
    'sg bakery ormeau': { postcode: 4208, tokens: ['ormeau', 'peachey', '4208'] },
    'sg bakery bogo': { postcode: 4102 },
    'sg bakery carseldine': { postcode: 4034, tokens: ['carseldine', 'beams', '4034'] },
    'tiffany\'s cakes & pastries': { postcode: 4053, tokens: ['tiffany', 'tiffanys', 'everton hills', 'queens road', '4053'] }
  };

  var SUBURB_COORDS_BY_QUERY = {
    'tewantin': { lat: -26.391, lng: 153.038 },
    'noosaville': { lat: -26.400, lng: 153.061 },
    'noosa': { lat: -26.397, lng: 153.090 },
    'noosa heads': { lat: -26.397, lng: 153.090 },
    'pereigian': { lat: -26.481, lng: 153.095 },
    'peregian springs': { lat: -26.493, lng: 153.075 },
    'coolum': { lat: -26.528, lng: 153.090 },
    'coolum beach': { lat: -26.528, lng: 153.090 },
    'marcoola': { lat: -26.584, lng: 153.094 },
    'mudjimba': { lat: -26.615, lng: 153.098 },
    'nambour': { lat: -26.626, lng: 152.960 },
    'buderim': { lat: -26.684, lng: 153.050 },
    'maroochydore': { lat: -26.653, lng: 153.091 },
    'mooloolaba': { lat: -26.681, lng: 153.119 },
    'sippy downs': { lat: -26.717, lng: 153.060 },
    'caloundra': { lat: -26.804, lng: 153.124 },
    'gympie': { lat: -26.189, lng: 152.665 },
    'caboolture': { lat: -27.084, lng: 152.951 },
    'morayfield': { lat: -27.108, lng: 152.949 },
    'burpengary': { lat: -27.157, lng: 152.957 },
    'burpengary east': { lat: -27.143, lng: 152.990 },
    'north lakes': { lat: -27.240, lng: 153.020 },
    'mango hill': { lat: -27.244, lng: 153.025 },
    'carseldine': { lat: -27.347, lng: 153.014 },
    'everton hills': { lat: -27.389, lng: 152.971 },
    'brisbane': { lat: -27.469, lng: 153.025 },
    'helensvale': { lat: -27.922, lng: 153.334 },
    'ormeau': { lat: -27.785, lng: 153.250 }
  };

  function normalize(text) {
    return String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function extractPostcode(text) {
    var matches = String(text || '').match(/\b\d{4}\b/g);
    return matches && matches.length ? parseInt(matches[matches.length - 1], 10) : null;
  }

  function debounce(fn, wait) {
    var timer = null;

    return function() {
      var args = arguments;
      var context = this;

      window.clearTimeout(timer);
      timer = window.setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  }

  function getState(root) {
    if (!root.__geniePickupNearestState) {
      root.__geniePickupNearestState = {
        showAll: false,
        isWriting: false,
        lastNote: '',
        lastSelectedLocationValue: '',
        searchQuery: '',
        searchMode: '',
        distanceFilterKm: null,
        cachedLocationItems: [],
        observer: null
      };
    }

    return root.__geniePickupNearestState;
  }

  function writeDom(root, callback) {
    var state = getState(root);
    state.isWriting = true;

    try {
      callback();
    } finally {
      window.setTimeout(function() {
        state.isWriting = false;
      }, 0);
    }
  }

  function getRootElements() {
    return document.querySelectorAll(ROOT_SELECTOR);
  }

  function findLocationContainer(root) {
    return root.querySelector('.locationContainer') || root;
  }

  function findLocationList(root) {
    return root.querySelector('.locationContainer > .locations') || root.querySelector('.locations');
  }

  function findNoLocationsMessage(root) {
    return root.querySelector('.no-locations-found');
  }

  function findSearchInput(root) {
    return (
      root.querySelector('.genieSearchLocation') ||
      root.querySelector('.geniePlaceSearch') ||
      root.querySelector('.genieZipcodeSearch') ||
      root.querySelector('input[placeholder*="postal" i]') ||
      root.querySelector('input[placeholder*="postcode" i]') ||
      root.querySelector('input[placeholder*="zip" i]')
    );
  }

  function findSuburbCoords(query) {
    var normalizedQuery = normalize(query);
    var keys = Object.keys(SUBURB_COORDS_BY_QUERY);

    if (!normalizedQuery || extractPostcode(normalizedQuery)) return null;

    for (var i = 0; i < keys.length; i += 1) {
      if (normalizedQuery === keys[i] || normalizedQuery.indexOf(keys[i]) !== -1 || keys[i].indexOf(normalizedQuery) !== -1) {
        return {
          label: keys[i],
          coords: SUBURB_COORDS_BY_QUERY[keys[i]]
        };
      }
    }

    return null;
  }

  function findLocationStepPanel(root) {
    return root.querySelector('.genie-location-step-panel');
  }

  function getLocationName(item) {
    var nameEl = item.querySelector('.locName') || item.querySelector('.locationDetailsHolder strong');
    return normalize(nameEl ? nameEl.textContent : item.textContent);
  }

  function findStoreKeyFromText(text) {
    var normalized = normalize(text);
    var keys = Object.keys(STORE_LOCATION_DATA_BY_NAME);

    for (var i = 0; i < keys.length; i += 1) {
      if (normalized.indexOf(normalize(keys[i])) !== -1) {
        return keys[i];
      }
    }

    for (var j = 0; j < keys.length; j += 1) {
      var storeData = STORE_LOCATION_DATA_BY_NAME[keys[j]];
      var tokens = storeData.tokens || [];

      for (var k = 0; k < tokens.length; k += 1) {
        if (normalized.indexOf(normalize(tokens[k])) !== -1) {
          return keys[j];
        }
      }
    }

    return false;
  }

  function storeMatchesTextQuery(item, query) {
    var normalizedQuery = normalize(query);
    var storeKey = findStoreKeyFromText(item.textContent);
    var storeData = storeKey ? STORE_LOCATION_DATA_BY_NAME[storeKey] : null;
    var haystack = normalize(item.textContent);
    var tokens = storeData && storeData.tokens ? storeData.tokens : [];

    if (!normalizedQuery) return true;
    if (haystack.indexOf(normalizedQuery) !== -1) return true;

    for (var i = 0; i < tokens.length; i += 1) {
      if (normalize(tokens[i]).indexOf(normalizedQuery) !== -1) {
        return true;
      }
    }

    return false;
  }

  function isKnownStoreText(text) {
    return Boolean(findStoreKeyFromText(text));
  }

  function isLocationItem(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches('input, button, script, style')) return false;
    if (node.classList.contains('genie-show-all-locations')) return false;
    if (node.classList.contains('genie-use-location-button')) return false;
    if (node.classList.contains('genie-nearest-note')) return false;
    if (node.classList.contains('genie-place-results')) return false;
    if (node.classList.contains('genie-place-result-item')) return false;

    return Boolean(
      node.classList.contains('location') ||
      node.classList.contains('loc-opt-holder') ||
      node.querySelector('.locName') ||
      node.querySelector('.locationDetailsHolder') ||
      node.querySelector('input[type="radio"]') ||
      isKnownStoreText(node.textContent)
    );
  }

  function getLocationItems(root) {
    var list = findLocationList(root);
    var items = [];

    if (!list) return items;

    items = Array.prototype.slice.call(list.children).filter(function(item) {
      return item.classList && item.classList.contains('location');
    });

    if (!items.length) {
      items = Array.prototype.slice.call(list.querySelectorAll('.location, .loc-opt-holder'))
        .filter(isLocationItem)
        .filter(function(item) {
          return item.parentElement === list;
        });
    }

    return items.filter(function(item, index) {
      return items.indexOf(item) === index;
    });
  }

  function cacheLocationItems(root) {
    var state = getState(root);
    var items = getLocationItems(root);

    if (items.length) {
      state.cachedLocationItems = items;
    }

    return state.cachedLocationItems || [];
  }

  function getStoreData(item) {
    var key = findStoreKeyFromText(item.textContent);
    return key ? STORE_LOCATION_DATA_BY_NAME[key] : null;
  }

  function getStoreCoords(item) {
    var key = findStoreKeyFromText(item.textContent);

    if (key && STORE_COORDS_BY_NAME[key]) {
      return STORE_COORDS_BY_NAME[key];
    }

    return null;
  }

  function getDistanceKm(item) {
    var value = item.getAttribute('data-genie-distance-km');
    return value ? parseFloat(value) : null;
  }

  function getStorePostcode(item) {
    var postcode = extractPostcode(item.textContent);
    if (postcode) return postcode;

    var storeData = getStoreData(item);
    return storeData ? storeData.postcode : null;
  }

  function getCustomerPostcode(root) {
    var input = findSearchInput(root);
    return input ? extractPostcode(input.value) : null;
  }

  function haversineKm(a, b) {
    var radius = 6371;
    var dLat = (b.lat - a.lat) * Math.PI / 180;
    var dLng = (b.lng - a.lng) * Math.PI / 180;
    var lat1 = a.lat * Math.PI / 180;
    var lat2 = b.lat * Math.PI / 180;
    var sinLat = Math.sin(dLat / 2);
    var sinLng = Math.sin(dLng / 2);
    var x = sinLat * sinLat + Math.cos(lat1) * Math.cos(lat2) * sinLng * sinLng;

    return radius * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }

  function selectedLocation(item) {
    return Boolean(
      item.matches('.active, .selected, .active-location') ||
      item.querySelector('input[type="radio"]:checked')
    );
  }

  function getSelectedLocationValue(root) {
    var selectedRadio =
      root.querySelector('.location input[type="radio"]:checked') ||
      root.querySelector('.location.active-location input[type="radio"]') ||
      root.querySelector('.location.active input[type="radio"]') ||
      root.querySelector('.location.selected input[type="radio"]');

    return selectedRadio ? selectedRadio.value : '';
  }

  function nudgePickupDetails(root) {
    var details = root.querySelector('.loc-opts');
    var state = getState(root);
    var selectedValue = getSelectedLocationValue(root);

    if (!details || !selectedValue || state.lastSelectedLocationValue === selectedValue) {
      return;
    }

    state.lastSelectedLocationValue = selectedValue;

    details.classList.add('genie-details-ready');

    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      window.setTimeout(function() {
        details.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 220);
    }
  }

  function setHidden(item, hidden) {
    item.classList.toggle('genie-location-hidden-by-limit', hidden);

    if (hidden) {
      item.style.setProperty('display', 'none', 'important');
    } else if (!item.classList.contains('genie-location-hidden-by-search')) {
      item.style.removeProperty('display');
    }
  }

  function setSearchHidden(item, hidden) {
    item.classList.toggle('genie-location-hidden-by-search', hidden);

    if (hidden) {
      item.style.setProperty('display', 'none', 'important');
    } else if (!item.classList.contains('genie-location-hidden-by-limit')) {
      item.style.removeProperty('display');
    }
  }

  function hideNativeNoLocations(root) {
    var noLocations = findNoLocationsMessage(root);

    if (noLocations) {
      noLocations.style.setProperty('display', 'none', 'important');
    }
  }

  function ensureLocationListFromCache(root) {
    var state = getState(root);
    var container = findLocationContainer(root);
    var panel = findLocationStepPanel(root);
    var list = findLocationList(root);
    var cachedItems = state.cachedLocationItems || [];
    var noLocations = findNoLocationsMessage(root);

    if (!cachedItems.length) {
      cacheLocationItems(root);
      cachedItems = state.cachedLocationItems || [];
    }

    if (!cachedItems.length) return list;

    hideNativeNoLocations(root);

    if (!list) {
      list = document.createElement('div');
      list.className = 'locations';

      writeDom(root, function() {
        var parent = panel || container;
        var beforeNode = noLocations || root.querySelector('.loc-opts') || null;
        if (beforeNode && beforeNode.parentNode !== parent) {
          beforeNode = null;
        }
        parent.insertBefore(list, beforeNode);
      });
    }

    if (!getLocationItems(root).length) {
      writeDom(root, function() {
        for (var i = 0; i < cachedItems.length; i += 1) {
          list.appendChild(cachedItems[i]);
        }
      });
    }

    return list;
  }

  function ensureLocationStepPanel(root) {
    var container = findLocationContainer(root);
    var input = findSearchInput(root);
    var list = findLocationList(root) || ensureLocationListFromCache(root);
    var panel = findLocationStepPanel(root);

    if (!container || !input || !list) return panel;

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'genie-location-step-panel';

      writeDom(root, function() {
        container.insertBefore(panel, input);
      });
    }

    writeDom(root, function() {
      var note = root.querySelector('.genie-nearest-note');
      var showButton = root.querySelector('.genie-show-all-locations');
      var locationButton = root.querySelector('.genie-use-location-button');
      var noLocations = findNoLocationsMessage(root);

      if (input.parentElement !== panel) panel.appendChild(input);
      if (locationButton && locationButton.parentElement !== panel) panel.appendChild(locationButton);
      if (note && note.parentElement !== panel) panel.appendChild(note);
      if (list.parentElement !== panel) panel.appendChild(list);
      if (noLocations && noLocations.parentElement !== panel) panel.appendChild(noLocations);
      if (showButton && showButton.parentElement !== panel) panel.appendChild(showButton);
    });

    return panel;
  }

  function addPickupMethodClass(root) {
    var methods = root.querySelectorAll(METHOD_SELECTOR);

    for (var i = 0; i < methods.length; i += 1) {
      if (isPickupMethod(methods[i])) {
        methods[i].classList.add('genie-method-pickup');
      }
    }
  }

  function isPickupMethod(method) {
    if (!method) return false;

    var text = normalize(method.textContent);
    return Boolean(
      method.classList.contains('genie-method-pickup') ||
      text.indexOf('pickup') !== -1 ||
      text.indexOf('pick up') !== -1 ||
      text.indexOf('in-store') !== -1 ||
      text.indexOf('store pickup') !== -1
    );
  }

  function getActiveMethod(root) {
    return (
      root.querySelector(METHOD_SELECTOR + '.active') ||
      root.querySelector(METHOD_SELECTOR + '[aria-selected="true"]') ||
      root.querySelector(METHOD_SELECTOR + '[data-active="true"]')
    );
  }

  function isPickupActive(root) {
    addPickupMethodClass(root);

    var activeMethod = getActiveMethod(root);
    if (activeMethod) {
      return isPickupMethod(activeMethod);
    }

    var checkoutMethodInput = root.querySelector('input[name="attributes[Checkout-Method]"]');
    if (checkoutMethodInput && normalize(checkoutMethodInput.value) === 'pickup') {
      return true;
    }

    return Boolean(root.querySelector('.locationContainer .locations, .locationContainer .location'));
  }

  function setPickupActiveState(root) {
    var active = isPickupActive(root);
    root.classList.toggle('genie-pickup-active', active);
    root.classList.toggle('genie-pickup-inactive', !active);
    return active;
  }

  function hidePickupControls(root) {
    var showButton = root.querySelector('.genie-show-all-locations');
    var locationButton = root.querySelector('.genie-use-location-button');
    var note = root.querySelector('.genie-nearest-note');
    var items = getLocationItems(root);

    for (var i = 0; i < items.length; i += 1) {
      setHidden(items[i], false);
    }

    if (showButton) showButton.style.setProperty('display', 'none', 'important');
    if (locationButton) locationButton.style.setProperty('display', 'none', 'important');
    if (note) note.style.setProperty('display', 'none', 'important');
  }

  function addOrUpdateNote(root, text) {
    var list = findLocationList(root);
    if (!list) return;

    var note = root.querySelector('.genie-nearest-note');
    var state = getState(root);
    state.lastNote = text || '';

    if (!note) {
      writeDom(root, function() {
        note = document.createElement('p');
        note.className = 'genie-nearest-note';
        list.parentNode.insertBefore(note, list);
      });
    }

    note.textContent = state.lastNote;
  }

  function addUseLocationButton(root) {
    var input = findSearchInput(root);
    if (!input) return null;

    var existing = root.querySelector('.genie-use-location-button');
    if (existing) return existing;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'genie-use-location-button';
    button.setAttribute('aria-label', 'Use my current location');
    button.innerHTML = '<span class="genie-use-location-button__icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M12 2v3"></path><path d="M12 19v3"></path><path d="M2 12h3"></path><path d="M19 12h3"></path><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg></span><span class="genie-use-location-button__text">Use my location</span>';

    writeDom(root, function() {
      input.insertAdjacentElement('afterend', button);
      root.classList.add('genie-has-location-button');
    });

    return button;
  }

  function addShowAllButton(root) {
    var list = findLocationList(root);
    var parent = findLocationStepPanel(root) || findLocationContainer(root);
    if (!list) return null;

    var existing = root.querySelector('.genie-show-all-locations');
    if (existing) return existing;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'genie-show-all-locations';

    writeDom(root, function() {
      parent.insertBefore(button, list.nextSibling);
    });

    button.addEventListener('click', function(event) {
      event.preventDefault();
      var state = getState(root);
      state.showAll = !state.showAll;
      applyLimit(root);
    });

    return button;
  }

  function updateShowAllButton(button, showAll, hiddenCount) {
    if (!button) return;

    button.textContent = showAll
      ? 'Show fewer pickup locations'
      : 'Show all pickup locations (' + hiddenCount + ' more)';
  }

  function applyLimit(root) {
    var active = setPickupActiveState(root);
    ensureLocationListFromCache(root);
    ensureLocationStepPanel(root);
    var items = getLocationItems(root);
    var showButton = addShowAllButton(root);
    var locationButton = addUseLocationButton(root);
    var note = root.querySelector('.genie-nearest-note');
    var state = getState(root);
    var hiddenCount = 0;
    var visibleIndex = 0;

    if (!active) {
      hidePickupControls(root);
      return;
    }

    for (var i = 0; i < items.length; i += 1) {
      var shouldHideBySearch = state.searchMode === 'text' && !storeMatchesTextQuery(items[i], state.searchQuery);
      var distanceKm = getDistanceKm(items[i]);

      if (state.searchMode === 'distance' && state.distanceFilterKm && distanceKm !== null && distanceKm > state.distanceFilterKm) {
        shouldHideBySearch = true;
      }

      var shouldHideByLimit = false;

      setSearchHidden(items[i], shouldHideBySearch);

      if (!shouldHideBySearch) {
        shouldHideByLimit = !state.showAll && visibleIndex >= LIMIT && !selectedLocation(items[i]);
        visibleIndex += 1;
      }

      setHidden(items[i], shouldHideByLimit);
      if (shouldHideByLimit) hiddenCount += 1;
    }

    if (showButton && visibleIndex > LIMIT) {
      showButton.style.removeProperty('display');
      updateShowAllButton(showButton, state.showAll, hiddenCount);
    } else if (showButton) {
      showButton.style.setProperty('display', 'none', 'important');
    }

    if (locationButton) {
      locationButton.style.removeProperty('display');
    }

    if (note) {
      if (state.lastNote) {
        note.style.removeProperty('display');
      } else {
        note.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function moveItemsInOrder(root, list, orderedItems) {
    var current = getLocationItems(root);
    var changed = false;

    if (current.length !== orderedItems.length) {
      changed = true;
    } else {
      for (var i = 0; i < current.length; i += 1) {
        if (current[i] !== orderedItems[i]) {
          changed = true;
          break;
        }
      }
    }

    if (!changed) return;

    writeDom(root, function() {
      for (var j = 0; j < orderedItems.length; j += 1) {
        list.appendChild(orderedItems[j]);
      }
    });
  }

  function sortByPostcode(root, customerPostcode) {
    var list = ensureLocationListFromCache(root) || findLocationList(root);
    var items = getLocationItems(root);

    if (!list || !items.length || !customerPostcode || !setPickupActiveState(root)) return false;

    items.sort(function(a, b) {
      var postcodeA = getStorePostcode(a);
      var postcodeB = getStorePostcode(b);

      if (!postcodeA && !postcodeB) return 0;
      if (!postcodeA) return 1;
      if (!postcodeB) return -1;

      return Math.abs(postcodeA - customerPostcode) - Math.abs(postcodeB - customerPostcode);
    });

    moveItemsInOrder(root, list, items);

    var state = getState(root);
    state.showAll = false;
    state.searchMode = 'postcode';
    state.distanceFilterKm = null;
    addOrUpdateNote(root, 'Showing pickup locations closest to postcode ' + customerPostcode + '.');
    applyLimit(root);
    return true;
  }

  function updateDistanceBadge(item, distance) {
    var holder = item.querySelector('.locationDetailsHolder') || item;
    var badge = item.querySelector('.genie-distance-badge');

    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'genie-distance-badge';
      holder.appendChild(badge);
    }

    badge.textContent = '~' + distance.toFixed(distance < 10 ? 1 : 0) + ' km away';
  }

  function clearDistanceBadges(root) {
    var badges = root.querySelectorAll('.genie-distance-badge');

    for (var i = 0; i < badges.length; i += 1) {
      badges[i].remove();
    }
  }

  function sortByCoords(root, customerCoords, label, radiusKm) {
    var list = ensureLocationListFromCache(root) || findLocationList(root);
    var items = getLocationItems(root);

    if (!list || !items.length || !customerCoords || !setPickupActiveState(root)) return false;

    var sortable = [];
    var missing = [];

    for (var i = 0; i < items.length; i += 1) {
      var coords = getStoreCoords(items[i]);

      if (coords) {
        var distance = haversineKm(customerCoords, coords);
        items[i].setAttribute('data-genie-distance-km', distance.toFixed(2));
        updateDistanceBadge(items[i], distance);

        sortable.push({
          item: items[i],
          distance: distance
        });
      } else {
        items[i].removeAttribute('data-genie-distance-km');
        missing.push(items[i]);
      }
    }

    if (!sortable.length) return false;

    sortable.sort(function(a, b) {
      return a.distance - b.distance;
    });

    var ordered = sortable.map(function(entry) {
      return entry.item;
    }).concat(missing);

    moveItemsInOrder(root, list, ordered);

    var state = getState(root);
    state.showAll = false;
    state.searchMode = label ? 'distance' : '';
    state.searchQuery = label || '';
    state.distanceFilterKm = radiusKm && sortable.some(function(entry) {
      return entry.distance <= radiusKm;
    }) ? radiusKm : null;

    addOrUpdateNote(
      root,
      label
        ? 'Showing pickup stores closest to ' + label + (state.distanceFilterKm ? ' within about ' + radiusKm + ' km.' : '.')
        : 'Showing the nearest pickup locations based on your current location. Matched ' + sortable.length + ' stores.'
    );
    applyLimit(root);
    return true;
  }

  function setLocationButtonLoading(button, loading) {
    if (!button) return;

    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
  }

  function requestBrowserLocation(root, button) {
    if (!setPickupActiveState(root)) {
      hidePickupControls(root);
      return;
    }

    if (!navigator.geolocation) {
      addOrUpdateNote(root, 'Your browser does not support location detection. Please enter your postcode.');
      applyLimit(root);
      return;
    }

    setLocationButtonLoading(button, true);

    navigator.geolocation.getCurrentPosition(
      function(position) {
        setLocationButtonLoading(button, false);

        var sorted = sortByCoords(root, {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }, '', null);

        if (!sorted) {
          addOrUpdateNote(root, 'Enter your postcode to sort pickup locations by nearest store.');
          applyLimit(root);
        }
      },
      function() {
        setLocationButtonLoading(button, false);
        addOrUpdateNote(root, 'Enter your postcode to sort pickup locations by nearest store.');
        applyLimit(root);
      },
      {
        enableHighAccuracy: false,
        timeout: 6000,
        maximumAge: 300000
      }
    );
  }

  function syncRoot(root) {
    addPickupMethodClass(root);
    cacheLocationItems(root);
    ensureLocationListFromCache(root);
    ensureLocationStepPanel(root);
    addUseLocationButton(root);
    addShowAllButton(root);
    applyLimit(root);
    bindSearchInput(root);
  }

  function sortFromSearch(root) {
    var input = findSearchInput(root);
    var query = input ? input.value : '';
    var postcode = extractPostcode(query);
    var state = getState(root);

    state.searchQuery = query;

    if (postcode) {
      clearDistanceBadges(root);
      sortByPostcode(root, postcode);
      return;
    }

    var suburbMatch = findSuburbCoords(query);

    if (suburbMatch) {
      sortByCoords(root, suburbMatch.coords, suburbMatch.label, SUBURB_DISTANCE_LIMIT_KM);
      return;
    }

    if (normalize(query).length >= 2) {
      clearDistanceBadges(root);
      var items = getLocationItems(root);
      var hasTextMatch = items.some(function(item) {
        return storeMatchesTextQuery(item, query);
      });

      if (!hasTextMatch) {
        state.searchMode = '';
        state.distanceFilterKm = null;
        state.showAll = false;
        addOrUpdateNote(root, 'No exact suburb match found. Showing available pickup stores.');
        applyLimit(root);
        return;
      }

      state.searchMode = 'text';
      state.distanceFilterKm = null;
      state.showAll = false;
      addOrUpdateNote(root, 'Showing pickup locations matching "' + query + '".');
      applyLimit(root);
      return;
    }

    state.searchMode = '';
    state.distanceFilterKm = null;
    state.showAll = false;
    clearDistanceBadges(root);

    applyLimit(root);
  }

  function bindSearchInput(root) {
    var input = findSearchInput(root);
    var state = getState(root);

    if (!input || input.getAttribute('data-genie-nearest-search-bound') === 'true') {
      return;
    }

    if (input.getAttribute('data-genie-nearest-owned') !== 'true') {
      var clonedInput = input.cloneNode(true);
      clonedInput.setAttribute('data-genie-nearest-owned', 'true');

      writeDom(root, function() {
        input.parentNode.replaceChild(clonedInput, input);
      });

      input = clonedInput;
    }

    input.setAttribute('data-genie-nearest-search-bound', 'true');

    var debouncedSearch = debounce(function() {
      sortFromSearch(root);
    }, SORT_DEBOUNCE_MS);

    input.addEventListener('input', function(event) {
      event.stopImmediatePropagation();
      debouncedSearch();
    }, true);

    state.searchQuery = input.value || '';
  }

  function startWarmSync(root) {
    var attempts = 0;
    var maxAttempts = 40;

    function run() {
      if (!document.documentElement.contains(root)) return;

      attempts += 1;
      syncRoot(root);
      bindSearchInput(root);

      if (attempts < maxAttempts) {
        window.setTimeout(run, 250);
      }
    }

    window.setTimeout(run, 80);
  }

  function bindRoot(root) {
    if (!root || root.getAttribute('data-genie-nearest-bound') === 'true') return;

    var state = getState(root);
    var scheduleSync = debounce(function() {
      if (state.isWriting) return;
      syncRoot(root);
    }, SYNC_DEBOUNCE_MS);

    root.setAttribute('data-genie-nearest-bound', 'true');
    startWarmSync(root);

    root.addEventListener('click', function(event) {
      var locationButton = event.target.closest('.genie-use-location-button');
      var method = event.target.closest(METHOD_SELECTOR);

      if (locationButton && root.contains(locationButton)) {
        event.preventDefault();
        requestBrowserLocation(root, locationButton);
        return;
      }

      if (method && root.contains(method)) {
        window.setTimeout(function() {
          syncRoot(root);
          bindSearchInput(root);
        }, 250);
      }
    });

    var debouncedRootSearch = debounce(function() {
      sortFromSearch(root);
    }, SORT_DEBOUNCE_MS);

    root.addEventListener('input', function(event) {
      var input = findSearchInput(root);

      if (input && event.target === input) {
        event.stopImmediatePropagation();
        debouncedRootSearch();
      }
    }, true);

    root.addEventListener('change', function(event) {
      if (event.target && event.target.matches('input[type="radio"]')) {
        window.setTimeout(function() {
          applyLimit(root);
          nudgePickupDetails(root);
        }, 120);
      }
    });

    state.observer = new MutationObserver(scheduleSync);
    state.observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  function refreshRoot(root) {
    if (!root) return;

    if (root.getAttribute('data-genie-nearest-bound') === 'true') {
      syncRoot(root);
      bindSearchInput(root);
      return;
    }

    bindRoot(root);
  }

  function init() {
    var roots = getRootElements();

    for (var i = 0; i < roots.length; i += 1) {
      refreshRoot(roots[i]);
    }
  }

  function startPageWatcher() {
    var attempts = 0;
    var maxAttempts = 80;
    var scheduled = false;

    if (pageWatcherStarted) {
      init();
      return;
    }

    pageWatcherStarted = true;

    function scheduleInit() {
      if (scheduled) return;

      scheduled = true;
      window.setTimeout(function() {
        scheduled = false;
        init();
      }, 100);
    }

    var interval = window.setInterval(function() {
      attempts += 1;
      init();

      if (attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    if (window.MutationObserver && document.documentElement) {
      var observer = new MutationObserver(scheduleInit);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPageWatcher);
  } else {
    startPageWatcher();
  }

  document.addEventListener('shopify:section:load', startPageWatcher);
})();
